/**
 * RFC-091 Extension: Partner Shared Templates Page
 * Dashboard for partners to manage templates shared with their client organizations
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import PartnerSharedTemplatesPage from '@/pages/partner/templates/PartnerSharedTemplatesPage';
import { ScrollArea } from '@deepguide-ai/ui/scroll-area';
import { Main } from '@/components/main';
import MainHeader from '@/components/layout/MainHeader';
import { Button } from '@deepguide-ai/ui/button';
import { ArrowLeft } from 'lucide-react';

export const Route = createFileRoute('/(protected)/partner/templates')({
  component: PartnerTemplatesPage,
});

function PartnerTemplatesPage() {
  const navigate = useNavigate();
  return (
    <ScrollArea className="h-screen w-full" viewClassName='[&>div]:!block'>
      <Main>
        <MainHeader showSidebarTrigger={false} />
        <div className='mx-auto box-content flex max-w-[1008px] flex-col space-y-6 px-6 pb-12'>
          {/* Back Navigation */}
          <Button
            variant="ghost"
            size="sm"
            className="w-fit -ml-2"
            onClick={() => navigate({ to: '/partner' })}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Partner Dashboard
          </Button>
          <PartnerSharedTemplatesPage/>

      </div>
      </Main>
    </ScrollArea>
  )
}
